import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class MobileNavigation {
    constructor() {
        this.init();
    }

    init() {
        let button = document.querySelector( '.mobile-search-button' ),
            search = document.querySelector( '.mobile-search' ),
            input = search.querySelector( '[data-search-form="input"]');

        if ( button === null ) {
            return;
        }

        button.addEventListener( 'click', ( e ) => {
            document.body.classList.add( 'mobile-search-opened' );

            disableBodyScroll( search, { reserveScrollBarGap: true } );
            input.focus();
        } );

        window.addEventListener( 'resize', ( e ) => {
            document.body.classList.remove( 'mobile-search-opened' );
            clearAllBodyScrollLocks();
        } );
    }
}
